<script>
export default {
  name: 'TopThreeSelection',
  functional: true,
  props: {
    ranking: {
      type: String,
      required: true,
    },
    selectionName: {
      type: String,
      required: true,
    },
    silkIconUrl: {
      type: String,
      required: true,
    },
    competitorNumber: {
      type: Number,
      required: true,
    },
  },
  render: (h, context) => {
    return (
      <div class="top-three-selection">
        <div class="top-three-selection__primary">
          <div class="top-three-selection__ranking">{context.props.ranking}</div>
          <div class="top-three-selection__barrier-num top-three-selection__competitor-number">
            {context.props.competitorNumber}
          </div>
          <div class="top-three-selection__image-wrap">
            <img class="top-three-selection__image" src={context.props.silkIconUrl} />
          </div>
        </div>
        <div class="top-three-selection__secondary">{context.props.selectionName}</div>
      </div>
    );
  },
};
</script>
